import { showDeleteConfirmation } from '@modules/common';
import { BaseBloc } from '@core/utils/bloc';
import { Repository } from '@core/utils/repository';
import { handleMessage, requestMessage } from '@business/messages';
import { switchMap } from 'rxjs/operators';
import { SenderResponse, SenderID } from '@business/entities/sender';
import { ChannelSenderAPI } from '@business/api/channelSender';
import { ChannelId } from '@business/entities/SupportChannel';

export class ChannelSenderBloc extends BaseBloc {
  private readonly senderRepo = new Repository<SenderResponse>({
    getItemId: sender => sender.id,
  });

  readonly senders$ = this.senderRepo.items$;

  onReset() {
    this.senderRepo.reset();
  }

  fetchSenders = (channelId: ChannelId) => {
    return ChannelSenderAPI.fetchSenders(channelId).pipe(
      this.senderRepo.ops.reset(),
      handleMessage({ error: requestMessage('fetch_email_senders') }),
    );
  };

  createSender = (channelId: ChannelId, senderId: SenderID, fromEmail: string, fromName: string) => {
    return ChannelSenderAPI.createSender(channelId, senderId, fromEmail, fromName).pipe(
      this.senderRepo.ops.addOne(item => item),
      handleMessage({
        type: requestMessage('create_email_sender'),
      }),
    );
  };

  makeDefault = (channelId: ChannelId, id: SenderID) => {
    return ChannelSenderAPI.makeDefault(channelId, id).pipe(
      this.senderRepo.ops.reset(),
      handleMessage({
        type: requestMessage('update_email_sender'),
      }),
    );
  };

  deleteSender = (channelId: ChannelId, senderId: SenderID) => {
    return showDeleteConfirmation('Delete Category', 'Do you really want to remove this category').pipe(
      switchMap(() => ChannelSenderAPI.deleteSender(channelId, senderId)),
      this.senderRepo.ops.removeOne(() => senderId),
      handleMessage({
        type: requestMessage('delete_email_sender'),
      }),
    );
  };
}
